var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatetales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.6429V5.5C4.5 5.16362 4.60994 4.92216 4.76605 4.76605C4.92216 4.60994 5.16362 4.5 5.5 4.5H26.5C26.8364 4.5 27.0778 4.60994 27.2339 4.76605C27.3901 4.92216 27.5 5.16362 27.5 5.5V17.6429L25.5036 15.6464L25.4959 15.6388L25.4879 15.6314C23.5055 13.8142 20.3498 13.7931 18.4964 15.6464L17.5 16.6429L13.5036 12.6464L13.4959 12.6388L13.4879 12.6314C11.5055 10.8142 8.34975 10.7931 6.49645 12.6464L4.5 14.6429ZM18.25 6.5C16.7739 6.5 15.5 7.77386 15.5 9.25C15.5 10.7261 16.7739 12 18.25 12C19.7261 12 21 10.7261 21 9.25C21 7.77386 19.7261 6.5 18.25 6.5ZM26.5 0.5H5.5C2.67386 0.5 0.5 2.67386 0.5 5.5V26.5C0.5 29.3261 2.67386 31.5 5.5 31.5H26.5C29.3261 31.5 31.5 29.3261 31.5 26.5V5.5C31.5 2.67386 29.3261 0.5 26.5 0.5Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatetales);
export default __webpack_public_path__ + "static/media/create tales.c1bf6312ede17a13b62b14172a6604d1.svg";
export { ForwardRef as ReactComponent };